const VOWELS = ["a", "e", "i", "o", "u"];

/**
 * Returns the correct English indefinite article ("a" or "an") for a word,
 * based on whether it begins with a vowel. This is a pragmatic heuristic that
 * covers job/hat titles (e.g. "an A/V Technician", "an Electrician") and does
 * not attempt to handle every phonetic edge case (e.g. "a university").
 */
export const indefiniteArticle = (word?: string): "a" | "an" => {
  const first = word?.trim().charAt(0).toLowerCase();
  if (!first) {
    return "a";
  }
  return VOWELS.includes(first) ? "an" : "a";
};
